export default {
  serverURL: "https://demo-server.aabvie.net" // 'https://backend-aab.aps-benin.com' //'http://localhost:13000'
}
